/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import InternationalizationStore from '../store/internationalization-store.js'
import {Table , Collapse , Nav , NavItem  ,FormControl , Form , FormGroup , ControlLabel , Col , Panel , Row , ButtonGroup , Button } from 'react-bootstrap';
import ClassService from '../services/classes-service.js';
import Search from "../components/tables/table.search.component.js";
import Layout from '../components/layouts/standard-page.js';
import ModuleService from '../services/screens-service.js';
import ModulesStore from '../store/screen-store.js';
import Select from  'react-select';
import CatalogService from '../services/catalog-service.js';
import VocabTable from '../components/tables/vocab-table.js';
import CurriculumService from '../services/curriculums-services.js'
import SearchService from '../services/search-service.js';
import LanguageSelector from '../components/inputs/language-selector.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import CDNImage from '../components/media/image.js';
import CDNAudio from '../classes/audio.js';
import Product from '../classes/product.js';

import $ from 'jquery';

export default class ContentStep extends React.Component {

    constructor(props){
        super();

        this.props = props;
        this.depth = 0;
        this.state = {
            tabIndex:0,
            multipleCurriculums:false,
            modules:[],
            selectedModules:[],
            moduleTiers:[],
            moduleDepth:0,
            selectableVocab:[],
        };

        this.handelTabSelect = this.handelTabSelect.bind(this);
        this.handelSelectLanguage = this.handelSelectLanguage.bind(this);
        this.handelCurriculumSelection = this.handelCurriculumSelection.bind(this);

        this.filterReferences = [{}, {}, {}, {}];
        this.currentSelection = 0;
    }

    getStandardOptions(value , label , object){
        return {value:value , label:label , object:object};
    }


    onSelectLanguage(language){
        var curriculums      = language.getCurriculums();
        this.language = language;
        this.catalogs = {};
        this.setState({selectedLanguage:language , curriculums:curriculums});
        this.handelCurriculumSelection(this.getStandardOptions(curriculums[0].uid , curriculums[0].getName() , curriculums[0]))
    }

    getCurriculumObject(id , translationID){
        return {value:id , label:<FormattedMessage id={ translationID || "default" } defaultMessage={ "Curriculum" }/>}
    }

    getModuleObject(parent , children , value , translationID , catalog_uid){
        return {parent:parent , children:children , value:value , label:translationID , catalog_uid:catalog_uid};
    }

    handelCurriculumSelection(curriculum , focus){
        this.setState({selectedCurriculum:curriculum});

        CurriculumService.getCurriculumData(curriculum.value).then(function(curriculumData){
            ModuleService.getModules(curriculumData.startScreen).then(function(response){
                ModulesStore.modules = ModulesStore.processModules(response);
                var modules =  ModulesStore.getArray();
                this.setState({modules:modules});
                this.handelModuleSelection(this.state.moduleDepth ,  {
                    parent:modules ,
                    children:modules[this.state.moduleDepth].subModules ,
                    value:modules[this.state.moduleDepth].uid ,
                    label:modules[this.state.moduleDepth].getName(),
                    catalog_uid:modules[this.state.moduleDepth].catalog_uid
                }, false, false);

                if(focus === true)
                {
                    this.filterReferences[0].focus();
                }

            }.bind(this));
        }.bind(this));
    }

    handelTabSelect(tabIndex){
        this.setState({tabIndex:tabIndex})
    }

    getCatalog(){

        var catalog = [];
        for(var idx = 0; idx < this.state.selectedModules.length; idx++)
        {
            if(this.state.selectedModules[idx].catalog_uid) catalog.push(this.state.selectedModules[idx].catalog_uid);
        }

        CatalogService.getCatalogVocab(catalog , this.state.selectedLanguage.ietf).then(function(response){
            this.setState({selectableVocab:response});
            if(!this.state.userChange || this.selectedVocabToArray().length == 0 )
            {
                this.addWholeSection();
                this.props.data.moduleID = this.state.selectedModules[idx - 1].value;
            }
        }.bind(this));
    }


    handelModuleSelection(key ,  option,  isClick, isFocus){
        var depth = key;


        if (isClick == undefined){
            isClick = true;
        }

        if (isFocus == undefined){
            isFocus = false;
        }

        if(isFocus){
            this.currentSelection = key;
        }

        var selectedModules = this.state.selectedModules;
        selectedModules[key] = option;

        var moduleTiers  = this.state.moduleTiers;
        moduleTiers[key] = this.renderModuleSelector.bind(this , option.parent, key);



        if(selectedModules[key].children && selectedModules[key].children.length > 0)
        {
            depth = depth + 1;
            var newOption = this.getModuleObject(selectedModules[key].children , selectedModules[key].children.subModules , selectedModules[key].children[0].uid , selectedModules[key].children[0].getName() , selectedModules[key].children[0].catalog_uid);
            this.handelModuleSelection(depth , newOption, false, isClick);
        }

        this.setState({selectedModules:selectedModules});
        this.getCatalog();
    }

    handelSelectLanguage(language){
        var curriculums      = language.getCurriculums();
        this.setState({selectedLanguage:language , curriculums:curriculums , multipleCurriculums:curriculums.length > 1});
        this.handelCurriculumSelection(this.getCurriculumObject(curriculums[0].uid , curriculums[0].getName()))
    }

    renderModuleSelector(modules , key){

        let filterModules = modules;

        modules = [];

        for(var idx = 0 ; idx < filterModules.length; idx++){


            if(filterModules[idx].isValid)
            {
                modules.push(filterModules[idx]);
            }

        }

        const options = modules.map(function (module) {
            return { value: module.uid, label: module.getName(), children: module.subModules, parent: modules, catalog_uid: module.catalog_uid }
        });

        this.filterReferences[key] = {};

        return <Select id={"focuse"+key} ref={(input) => { this.filterReferences[key] = input; } } autoFocus={ key == 0 } openOnFocus={false} className={""} onChange={this.handelModuleSelection.bind(this, key)}
                       value={this.state.selectedModules[key]} options={options} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
                       placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
    }

    renderCurriculumMultiSelect(){


        const options = this.state.selectedLanguage.getCurriculums().map(function(curriculum){
            return  this.getStandardOptions(curriculum.uid , curriculum.getName() , curriculum);
        }.bind(this));

        this.filterReferences[0] = {};

        return <Select ref={(input) => { this.filterReferences[0] = input; } } autoFocus={false} openOnFocus={true} className={""} onChange={this.handelCurriculumSelection} value={this.state.selectedCurriculum} options={options}
                       noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                       placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

    renderFilters(){

        var filters = (this.state.multipleCurriculums ? [this.renderCurriculumMultiSelect()] : []).concat(this.state.moduleTiers.map(function(item , index){
            console.log(index);

            return item();

        }));

        var sm = Math.ceil(12/filters.length);

        return filters.map(function(item){
            return <Col sm={sm}className="actionBar p-5"  >{item}</Col>
        });
    }

    renderSearchHeader(){
        if(this.state.tabIndex == 0) return
    }

    selectedVocabToArray(){
       return [];
    }

    handelVocabSelection( userChange , vocab ){

        this.setState({selectedVocab:vocab , userChange:userChange})
        this.props.data.selectedVocab = this.selectedVocabToArray();
        if(userChange) this.props.data.moduleID = null;
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){

                if(this.search.value.length <= 0) return;
                SearchService.searchLearning(this.search.value , this.state.selectedLanguage.ietf).then(function(response){
                    this.setState({selectableVocab:response.searchResults})
                }.bind(this));

            }.bind(this), 500)
        });
    }


    clear(){
        this.handelVocabSelection(true , {});
        this.setState({tabIndex:0});
    }

    handelAudioClick(src){
        (new CDNAudio(src)).play();
    }

    downloadContent(file) {

        var currLang = sessionStorage.getItem("interfaceLanguage");
        var content;
        if (currLang == "undefined" || currLang == undefined || currLang == null ){
            content = "en";
        } else if (currLang == "en-US"){
            content = "en-US";
        } else if (currLang == "es" || currLang == "es-MX"){
            content = "es";
        } else {
            content = "en";
        }

        var isHuber = false;
        isHuber = (new Product()).isHuber();

        var link;
        if (content == "en-US"){
            link = "https://s3.eu-central-1.amazonaws.com/assets.languagenut.com/content/American%20MARS%20v3.pdf";
        } else if (content == "es"){
            link = "https://s3.eu-central-1.amazonaws.com/assets.languagenut.com/content/Spanish-MARS-%20v2.pdf";
        } else {
            link = "https://s3.eu-central-1.amazonaws.com/assets.languagenut.com/content/MARS%20UK%20v2.pdf";
        }

        if ( isHuber != false  ) {
            link =  "https://s3.eu-central-1.amazonaws.com/assets.languagenut.com/content/Schritte%20Plus%20Content%20Map.pdf";
        }


        window.open(link, '_blank');
    }


    render(){

        const language = <LanguageSelector onSelect={this.onSelectLanguage.bind(this)}/>;
        if(!this.state.curriculums) return <Layout>{language}</Layout>;


        let rows = this.state.selectableVocab.map(function(vocab){

            let learningAudio = <td className="p-0" width={20}>
                    <button onClick={this.handelAudioClick.bind(this ,  vocab.learningAudio)} type="button" className="palette-White-Disabled bg  small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                        <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png"/>
                    </button>
            </td>

            if(vocab.word == vocab.originalWord)
            {
                return <tr>{learningAudio}<td>{vocab.word}</td></tr>
            }

            let supportAudio = <td className="p-0" width={20}>
                    <button onClick={this.handelAudioClick.bind(this ,  vocab.audio)} type="button" className="palette-White-Disabled bg  small btn btn-icon command-edit waves-effect waves-circle" data-row-id="10248">
                        <CDNImage className="m-b-5" size={15} src="img/audioWordPod.png"/>
                    </button>
            </td>

            return <tr>{learningAudio}<td>{vocab.word}</td>{supportAudio}<td>{vocab.originalWord}</td></tr>
        }.bind(this));

        let download = null;
        if((new Product()).isContentOverviewAvaliable())
        {
            //826
            download = <Button className="pull-right btn-primary" onClick={this.downloadContent.bind(this)}><i className="palette-White text zmdi zmdi-download"></i> <FormattedMessage id={ 'ui-826' } defaultMessage={ 'Search for vocabulary' }/></Button>
        }

        return <Layout>

            <Card>
                <CardHead>
                    <h4 className="pull-left">
                        <FormattedMessage id={ 'ui-123' } defaultMessage={ 'Search for vocabulary' }/>
                    </h4>
                    {download}
                </CardHead>
                <CardBody>
                    <Row>
                        <Col sm={12} className="p-l-5 actionBar"  >
                            {language}
                        </Col>
                    </Row>
                    <Row className="p-l-0 p-r-10">
                        {this.renderFilters()}
                    </Row>
                    <Row>
                        <Table condensed striped responsive bordered>
                            <tbody>
                                {rows}
                            </tbody>
                        </Table>
                    </Row>
                </CardBody>
            </Card>
        </Layout>

    }
}


// WEBPACK FOOTER //
// ./src/screens/content-map-update.js